import { FETCH_REVIEW_INFO } from '../actions/types'

export interface ReviewInfoProps {
  data: any
  loading: boolean
}

interface ReviewInfoAction extends ReviewInfoProps {
  type: string
}

const initialReviewInfoState: ReviewInfoProps = {
  loading: false,
  data: null,
}

export const reviewInfo = (
  state: ReviewInfoProps = initialReviewInfoState,
  { type, data, loading }: ReviewInfoAction,
) => {
  switch (type) {
    case FETCH_REVIEW_INFO:
      return { data, loading }

    default:
      return state
  }
}
